// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"980ea7a5","101":"84ed6ccd","395":"93708c24","457":"508c0f6b","762":"007a0e5d","775":"67cb333c","904":"481faf56","973":"8908e1b6"}[chunkId] + ".chunk.js";
};